<template>
    <footer class="footer text-center pt-2 pb-5">
        <small class="copyright">Copyright &copy; 2020 - 2024</small>
    </footer>
</template>
<script>
    export default {
        name: "ProjectFooter"
    }
</script>
<style lang="sass" scoped>
    .fa-heart
        color: #fb866a
</style>